module.exports = __webpack_public_path__ + "img/icon-arrow-left.bc1af60b.svg";